import './App.css';
import React, { Component } from 'react';

class App extends Component {
  constructor(props) {
    super(props);
    this.state = {
      marked: 3,
    };
    this.toggleRead = this.toggleRead.bind(this);
  }
  toggleRead() {
    this.setState({
      marked: 0,
    });
  }
  render() {
    return (
      <div className="box-main">
        <div className="interface-main">
          <div className="hint">
            Notifications<div className="number">{this.state.marked}</div>
          </div>
          <div onClick={this.toggleRead} className="clear">
            Mark all as read
          </div>
        </div>
        <div className="box-list">
          <div
            className={
              this.state.marked === 3 ? 'notification read' : 'notification'
            }
          >
            
              <img
                className="avatar"
                alt="avatar"
                src={require("./users avatars/avatar-mark-webber.webp")}
              ></img>
            
            <div className="info">
              <span className="user-bold">Mark Webber</span>reacted to your
              recent post
              <span className="user-bold gray">My first tournament today!</span>
              {this.state.marked === 3 ? (
                <div className="red-point"></div>
              ) : null}
              <div className="ago gray">1m ago</div>
            </div>
          </div>
          <div
            className={
              this.state.marked === 3 ? 'notification read' : 'notification'
            }
          >
            
              <img
                className="avatar"
                alt="avatar"
                src={require("./users avatars/avatar-angela-gray.webp")}
              ></img>
            
            <div className="info">
              <span className="user-bold">Angela Gray </span>followed you
              <span className="user-bold gray"></span>
              {this.state.marked === 3 ? (
                <div className="red-point"></div>
              ) : null}{' '}
              <div className="ago gray">5m ago</div>
            </div>
          </div>
          <div
            className={
              this.state.marked === 3 ? 'notification read' : 'notification'
            }
          >
            
              <img
                className="avatar"
                alt="avatar"
                src={require("./users avatars/avatar-jacob-thompson.webp")}
              ></img>
            
            <div className="info">
              <span className="user-bold">Jacob Thompson</span>has joined your
              group
              <span className="user-bold gray">Chess Club</span>
              {this.state.marked === 3 ? (
                <div className="red-point"></div>
              ) : null}{' '}
              <div className="ago gray">1 day ago</div>
            </div>
          </div>
          <div className="notification">
            
              <img
                className="avatar"
                alt="avatar"
                src={require("./users avatars/avatar-rizky-hasanuddin.webp")}
              ></img>
            
            <div className="info">
              <span className="user-bold">Rizky Hasanuddin</span>sent you a
              private message
              <span className="user-bold gray"></span>
              <div className="ago gray">5 days ago</div>
              <div className="message">
                Hello, thanks for setting up the Chess Club. I've been a member
                for a few weeks now and I'm already having lots of fun and
                improving my game.
              </div>
            </div>
          </div>
          <div className="notification ">
            
              <img
                className="avatar"
                alt="avatar"
                src={require("./users avatars/avatar-kimberly-smith.webp")}
              ></img>
            
            <div className="info">
              <span className="user-bold">Kimberly Smith</span>commented on your
              picture
              <span className="user-bold gray"></span>
              <div className="ago gray">1 week ago</div>
            </div>

            <img
            alt="chess"
              className="photo-mean"
              src={require("./users avatars/image-chess.webp")}
            ></img>
          </div>
          <div className="notification ">
            
              <img
                className="avatar"
                alt="avatar"
                src={require("./users avatars/avatar-nathan-peterson.webp")}
              ></img>
            
            <div className="info">
              <span className="user-bold">Nathan Peterson</span>reacted to your
              recent post
              <span className="user-bold gray">
                5 end-game strategies to increase your win rate
              </span>
              <div className="ago gray">2 weeks ago</div>
            </div>
          </div>
          <div className="notification ">
            
              <img
                className="avatar"
                alt="avatar"
                src={require("./users avatars/avatar-anna-kim.webp")}
              ></img>
            
            <div className="info">
              <span className="user-bold">Anna Kim</span>left the group
              <span className="user-bold gray">Chess Club</span>
              <div className="ago gray">2 weeks ago</div>
            </div>
          </div>
        </div>
      </div>
    );
  }
}

export default App;
